export const createAbsoluteUrl = (path: string) => {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    path = path.startsWith('/') ? path : `/${path}`;
    const absoluteUrl = origin + path;
    return absoluteUrl;
};
